module.exports = __webpack_public_path__ + "static/media/customer_payment.adf56278.png";